export enum GingivalFestooning {
    Light = 1,
    Medium = 2,
    High = 3,
}
